// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const styles = theme => ({
  mainContainer: {
    width: '100%',
    minHeight: '100vh',
  },
  mainContent: {
    paddingBottom: 200,
    [theme.breakpoints.down(500)]: {
      paddingBottom: 300,
    },
    [theme.breakpoints.down(330)]: {
      paddingBottom: 400,
    },
  },
  mobileImageContainer: {
    position: 'absolute',
    zIndex: -1,
    top: 0,
    right: 0,
    width: 135,
  },
  phone: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: -1,
    width: 700,
    [theme.breakpoints.down(1500)]: {
      width: 520,
    },
    [theme.breakpoints.down(1200)]: {
      width: 400,
    },
    [theme.breakpoints.down(1150)]: {
      width: 450,
    },
    [theme.breakpoints.down(1100)]: {
      width: '40%',
    },
    [theme.breakpoints.down(1100)]: {
      width: '35%',
    },
  },
  leftBottomBackground: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '30%',
    zIndex: -1,
  },
  leftTopBackground: {
    position: 'absolute',
    left: 0,
    top: 100,
    width: 100,
  },
  rightTopBackground: {
    position: 'absolute',
    right: 0,
    top: 0,
    width: 180,
    zIndex: -1,
  },
  mobileRightTopBackground: {
    position: 'absolute',
    right: 0,
    top: 0,
    width: 140,
    zIndex: -1,
  },
  image: {
    maxWidth: '100%',
  },
  rectangle1: {
    width: 50,
    height: 50,
    maxWidth: 50,
    position: 'absolute',
    top: 90,
    right: 20,
    [theme.breakpoints.down(600)]: {
      width: 30,
      height: 30,
      top: 130,
      right: 60,
    },
  },
  topLikeIndexRectangle1: {
    [theme.breakpoints.down(600)]: {
      width: 30,
      height: 30,
      top: 130,
      right: 60,
    },
  },
  topNotLikeIndexRectangle1: {
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  rectangle2: {
    width: 35,
    height: 35,
    maxWidth: 35,
    position: 'absolute',
    top: 160,
    right: 90,
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  rectangle2IsIndex: {
    display: 'none',
    [theme.breakpoints.down(600)]: {
      display: 'block',
      width: 25,
      height: 25,
      position: 'absolute',
      top: 520,
      left: '60%',
    },
  },
  blueRectangle: {
    width: 20,
    height: 20,
    position: 'absolute',
    top: 600,
    right: 200,
    [theme.breakpoints.down(1000)]: {
      right: 100,
    },
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  pinkRectangle: {
    width: 15,
    height: 15,
    position: 'absolute',
    top: 250,
    right: 80,
  },
  pinkRectangleIsIndex: {
    [theme.breakpoints.down(600)]: {
      width: 15,
      height: 15,
      position: 'absolute',
      top: 550,
      left: '20%',
    }
  },
  pinkRectangleIsNotIndex: {
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  blueRectangleLeft1: {
    width: 15,
    height: 15,
    position: 'absolute',
    top: 520,
    left: 130,
    [theme.breakpoints.down(1000)]: {
      left: 80,
    },
  },
  blueRectangleLeft1IsIndex: {
    [theme.breakpoints.down(600)]: {
      top: 150,
      left: 100,
    },
  },
  blueRectangleLeft1IsNotIndex: {
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  blueRectangleLeft2: {
    width: 15,
    height: 15,
    position: 'absolute',
    top: 400,
    left: 200,
    [theme.breakpoints.down(1000)]: {
      left: 100,
    },
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  rectanglePackGuide: {
    width: 40,
    height: 40,
    position: 'absolute',
    top: 400,
    right: 200,
    [theme.breakpoints.down(1000)]: {
      right: 100,
    },
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  rectangleHowItWorksTop: {
    width: 40,
    height: 40,
    position: 'absolute',
    top: 700,
    left: 200,
    [theme.breakpoints.down(1000)]: {
      left: 100,
    },
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  rectangleHowItWorksBottom: {
    width: 40,
    height: 40,
    position: 'absolute',
    top: 900,
    left: 130,
    [theme.breakpoints.down(1000)]: {
      left: 80,
    },
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  rectangleHiwTopRight: {
    top: 200,
    right: 250,
    width: 50,
    height: 50,
    position: 'absolute',
    [theme.breakpoints.down(1000)]: {
      right: 150,
    },
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  rectangleHIWBottomRightTop: {
    bottom: 700,
    right: 200,
    width: 50,
    height: 50,
    position: 'absolute',
    [theme.breakpoints.down(1000)]: {
      right: 30,
    },
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  rectangleHIWBottomRightBottom: {
    bottom: 300,
    right: 200,
    width: 50,
    height: 50,
    position: 'absolute',
    [theme.breakpoints.down(1000)]: {
      right: 80,
    },
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  rectangleHIWBottomLeft: {
    bottom: 350,
    left: 200,
    width: 40,
    height: 40,
    position: 'absolute',
    [theme.breakpoints.down(1000)]: {
      left: 100,
    },
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  zigzagLines: {
    position: 'absolute',
    bottom: -45,
    right: 70,
    [theme.breakpoints.down(1200)]: {
      maxWidth: 100,
    },
    [theme.breakpoints.down(1100)]: {
      right: 40,
    },
  }
});

export default styles;
